import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { EditProjectContextProps } from "../../../EditProjectContext";
import { getRouteWithOriginRegion } from "../../../GetRouteWithOriginRegion";

export async function setChangedRoute(
  route: FtlRouteViewModel,
  projectContextProps: EditProjectContextProps,
  equipment: string | undefined = route.Equipment
) {
  const { project, setProject } = projectContextProps;
  const routeWithOriginRegion = await getRouteWithOriginRegion(
    { ...route, Equipment: equipment },
    project.StartDateDisplay
  );

  const ftlRoutes = project.FTLRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteId === route.RouteId) {
      return routeWithOriginRegion;
    }
    return ftlRoute;
  });

  setProject({
    ...project,
    FTLRoutes: ftlRoutes,
  });
}
